@if (breadcrumbItems().length > 0) {
  <div class="breadcrumb-wrapper">
    <lib-breadcrumb [items]="breadcrumbItems()" [separator]="'ChevronRight'" />
  </div>
}
